<template>
  <v-container fluid style="padding-right:0px; padding-bottom:0px">
    <v-slide-y-transition mode="out-in">
      <div class="hot">
        <hot-table :settings="hotSettings" :data="videos" />
      </div>
    </v-slide-y-transition>
  </v-container>
</template>

<script>
  import { HotTable } from '@handsontable/vue'
  import Handsontable from 'handsontable'
  import cloudinaryData from '../../../../static/dummy-data/sample-videos-totag-vagotv.json'

  export default {
    name: 'TagVideo',
    components: {
      HotTable
    },
    data () {
      return {
        hotSettings: {
          licenseKey: 'non-commercial-and-evaluation',
          nestedHeaders: [
            [
              {label: '', colspan: 1},
              {label: 'Video', colspan: 3},
              {label: 'Album', colspan: 2},
              {label: 'District', colspan: 2},
              {label: 'Spec', colspan: 3}
            ],
            ['', 'ID', 'Name', 'Lead', 'Album', 'Topic', 'District', 'Candidate', 'Length (s)', 'Width', 'Height']
          ],
          columns: [
            {
              data: 'filename',
              readOnly: true,
              renderer: function (instance, td, row, col, prop, value, cellProperties) {
                const escaped = Handsontable.helper.stringify(value)
                let img = null
                let url = 'https://res.cloudinary.com/outfox-ai/video/upload/w_100,h_100,c_fill,g_auto/va-gotv-video/' + escaped + '.png'

                if (url.indexOf('http') === 0) {
                  img = document.createElement('IMG')
                  img.src = url

                  Handsontable.dom.addEvent(img, 'mousedown', function (event) {
                    event.preventDefault()
                  })

                  Handsontable.dom.empty(td)
                  td.appendChild(img)
                } else {
                  Handsontable.renderers.TextRenderer.apply(this, arguments)
                }

                return td
              }
            },
            {data: 'filename',
              readOnly: true
            },
            {data: 'context.title'
            },
            {data: 'context.lead'},
            {data: 'context.album'
            },
            {data: 'context.issue'},
            {data: 'context.district',
              type: 'autocomplete',
              source: ['VA-HD-62', 'VA-HD-84', 'VA-HD-100'],
              strict: false
            },
            {data: 'context.candidate'},
            {data: 'duration',
              type: 'numeric',
              numericFormat: {
                pattern: '0.0',
                culture: 'en-US'
              },
              readOnly: true
            },
            {data: 'width',
              type: 'numeric',
              readOnly: true
            },
            {data: 'height',
              type: 'numeric',
              readOnly: true
            }
          ],
          rowHeaders: true,
          rowHeights: 100,
          width: '100%',
          stretchH: 'all',
          height: 560,
          fixedColumnsLeft: 1,
          cells: function (row, col) {
            var cellProperties = {}

            if (col === 0) {
              cellProperties.colWidths = 100
            } else if (col === 1) {
              cellProperties.colWidths = 150
            } else if (col === 2) {
              cellProperties.colWidths = 200
            }

            return cellProperties
          },
          dropdownMenu: ['filter_by_value', 'filter_action_bar'],
          filters: true,
          headerTooltips: {
            columns: true,
            onlyTrimmed: true
          },
          hiddenColumns: {
            indicators: true
          }
        }
        // id: 'my-custom-id',
        // className: 'my-custom-classname',
        // style: 'width: 300px; height: 142px; overflow: hidden; border: 1px solid red;'
      }
    },
    computed: {
      videos: function () {
        return cloudinaryData.filter(function (obj) {
          return (obj.resource_type === "video" && obj.folder !== "samples")
        })
      }
    }
  }
</script>
<style>
    .component-fade-enter-active, .component-fade-leave-active {
        transition: opacity .3s ease;
    }
    .component-fade-enter, .component-fade-leave-to
        /* .component-fade-leave-active below version 2.1.8 */ {
        opacity: 0;
    }
    .switch label {
      color: white!important
    }
</style>
